import type { ProductInformation } from '@hotjar/product-catalog';

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(): void {}

export function productsSortingFunction(
  a: ProductInformation | undefined,
  b: ProductInformation | undefined,
): number {
  const sortedProducts: ProductInformation['product']['name'][] = ['observe', 'ask'];
  if (a === undefined || b === undefined) {
    return 0;
  }
  return sortedProducts.indexOf(a.product.name) - sortedProducts.indexOf(b.product.name);
}
